<div class="search-bar-field-status">
  <span *ngIf="type == 'version'">
    <span>Is </span>
    <span class="status-action" title="{{filter.item.name}}" [ngStyle]="{'color': filter.item.color}">
        {{filter.item.name}}
    </span>
  </span>
  <span *ngIf="type == 'project'">
    <span>{{filter.item.workflow.name}} > </span>
    <span class="status-action" title="{{filter.item.status.name}}" [ngStyle]="{'color': filter.item.status.color}">
        {{filter.item.status.name}}
    </span>
  </span>
  <span
      title="Remove status filter"
      class="status-action-btn"
      [ngClass]="style"
      (click)="onRemove(filter)"
  >X</span>
</div>
